import axios from "axios";
import URLHelper from "../helpers/URLHelper";

const FeedingServices = {
  getFeeding: async (patient, date_from, date_to) => {
    let args = "";
    if (date_from && date_to) {
      args =
        patient === null
          ? ""
          : `?patient=${URLHelper.encodeQueryParamValue(patient)}&date_from=${date_from}&date_to=${date_to}`;
    } else {
      args =
        patient === null ? "" : `?patient=${URLHelper.encodeQueryParamValue(patient)}&date_from=${date_from}`;
    }
    const response = await axios.get(
      process.env.REACT_APP_API_URL + `/feeding/${args}`
    );
    return response;
  },
  getWater: async (patient, date_from, date_to) => {
    let args = `?patient=${URLHelper.encodeQueryParamValue(patient)}&type=water&from=${date_from}`;
    if (date_to) {
      args += patient === null ? "" : `&to=${date_to}`;
    }
    const response = await axios.get(
      process.env.REACT_APP_API_URL + `/rpm/control/history${args}`
    );
    return response;
  },
};

export default FeedingServices;
